import { call, put, takeEvery } from 'redux-saga/effects';
import { getBikesForPartEx } from '../../requests/get_bikes_for_part_ex_request';
import { getBikesForPartExSuccess, getBikesForPartExFailure } from '../actions/get_bikes_for_par_ex.actions';
import { GET_BIKES_FOR_PART_EX_REQUEST } from '../constants/get_bikes_for_part_ex.constants';
import { getBikeBrands } from '../../requests/get_bike_brands_request';
import { getBikeBrandsFailure } from '../actions/get_bike_brands.actions';


function* getBikesForPartExRequest({ params }) {
    const brands = yield call(getBikeBrands, params);

    if (!brands.error) {
        if (brands.options.length !== 0) {
            const params_for_part_ex = { brandId: brands.options[0]._id };
            const bikes_for_part_ex = yield call(getBikesForPartEx, params_for_part_ex);
            const { msg, result, options } = bikes_for_part_ex;

            if (result) {
                yield put(getBikesForPartExSuccess(options));
            } else {
                yield put(getBikesForPartExFailure(msg));
            }
        }
    } else {
        yield put(getBikeBrandsFailure(brands.msg));
        yield put(getBikesForPartExFailure(brands.msg));
    }
}

export default function* getBikeForPartExSaga() {
    yield takeEvery(GET_BIKES_FOR_PART_EX_REQUEST, getBikesForPartExRequest);
}



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_create/redux/sagas/get_bikes_for_part_ex.saga.js